export const CARD_TYPE = 'card type';
export const FROM = 'from';
export const CURRENCY = 'currency';
export const FROM_CURRENCY = 'from currency';
export const TO = 'to';
export const TO_CURRENCY = 'to currency';
export const ACCOUNT_CURRENCY = 'account currency';
export const LEVEL = 'level';
export const METHOD = 'method';
export const METHOD_TYPE = 'method_type';
export const DELIVERY_METHOD_AMPLITUDE = 'delivery method';
export const DELIVERY_METHOD_AMPLITUDE_UND = 'delivery_method';
export const SENDING_METHOD_AMPLITUDE = 'sending method';
export const PAYMENT_METHOD_AMPLITUDE = 'payment_method';
export const PURPOSE_TO = 'purpose to';
export const PURPOSE_FROM = 'purpose from';
export const TRANSFER_ID = 'transfer id';
export const GLOBAL_METHODS = 'global_methods';
export const IS_LINKED_TO_CARD = 'is linked to card';
export const PRODUCT_NAME = 'product name';
export const COUNTRY = 'country';
export const COUNTRY_OF_RESIDENCE = 'country of residence';
export const COUNTRY_TO = 'country_to';
export const COUNTRY_FROM = 'country_from';
export const RECEIVING_COUNTRY = 'receiving_country';
export const DOCUMENT_TYPE = 'document type';
export const GT_LEVEL = 'GT_level';
export const GA_LEVEL = 'GA_level';
export const TYPE = 'type';
export const STATUS = 'status';
export const SCREEN_TYPE = 'screen_type';
export const NETWORK = 'network';
export const PAYMENT_FLOW = 'payment_flow';
export const SUGGESTED = 'suggested';
export const TO_PRV_CATEGORY = 'to_prv_category';
export const SCENARIO_ID = 'scenario_id';
export const AMOUNT = 'amount';
export const AMOUNT_FROM_AMPLITUDE = 'amount_from';
export const AMOUNT_TO_AMPLITUDE = 'amount_to';
export const AWAITING_STATUS = 'awaiting_status';
export const LIMIT_TYPE = 'limit_type';
export const UI_LANGUAGE = 'ui_language';
export const KYC_PROVIDER = 'kyc_provider';
export const ID_DOCUMENT_TYPE = 'document_type';
export const PHONE_NUMBER = 'phone_number';
export const IS_LOW_RISK = 'is_low_risk';
export const SCREEN = 'screen';
export const IS_IMPROVED_RATE = 'is_improved_rate';
export const FLOW = 'flow';
export const RECIPIENT_TYPE = 'recipient_type';
export const PAYMENT_METHOD_CATEGORY = 'payment_method_category';
export const PAYMENT_COUNTRY = 'payment_country';
export const PAYMENT_CURRENCY = 'payment_currency';
export const PAYOUT_METHOD_CATEGORY = 'payout_method_category';
export const PAYOUT_COUNTRY = 'payout_country';
export const PAYOUT_CURRENCY = 'payout_currency';
export const PAYOUT_METHOD = 'payout_method';
export const PAYMENT_METHOD_TYPE = 'payment_method_type';
export const PERIOD = 'period';
export const PHONE_COUNTRY = 'phone_country';
export const NEW_PHONE_COUNTRY = 'new_phone_country';
export const TOS_TYPE = 'tos_type';
export const FIELD_NAME = 'field_name';
export const FIELD_VALUE = 'field_value';
export const SOF = 'sof';
export const ERROR = 'error';
export const ICON_TYPE = 'icon_type';
export const ARTICLE = 'article';
export const SECTION = 'section';
export const TRANSFER_COUNT = 'transfer_count';
export const BANNER_NAME = 'banner_name';
export const BUTTON_VARIANT = 'button_variant';
export const CATEGORY = 'category';

export const AMPLITUDE_PARAM_NAMES = {
    CARD_TYPE,
    FROM,
    CURRENCY,
    FROM_CURRENCY,
    TO,
    TO_CURRENCY,
    ACCOUNT_CURRENCY,
    LEVEL,
    METHOD,
    METHOD_TYPE,
    DELIVERY_METHOD_AMPLITUDE,
    DELIVERY_METHOD_AMPLITUDE_UND,
    SENDING_METHOD_AMPLITUDE,
    PAYMENT_METHOD_AMPLITUDE,
    PURPOSE_TO,
    PURPOSE_FROM,
    TRANSFER_ID,
    GLOBAL_METHODS,
    IS_LINKED_TO_CARD,
    PRODUCT_NAME,
    COUNTRY,
    COUNTRY_OF_RESIDENCE,
    COUNTRY_TO,
    COUNTRY_FROM,
    RECEIVING_COUNTRY,
    DOCUMENT_TYPE,
    GT_LEVEL,
    GA_LEVEL,
    TYPE,
    STATUS,
    SCREEN_TYPE,
    NETWORK,
    PAYMENT_FLOW,
    SUGGESTED,
    TO_PRV_CATEGORY,
    SCENARIO_ID,
    AMOUNT,
    AMOUNT_FROM_AMPLITUDE,
    AMOUNT_TO_AMPLITUDE,
    AWAITING_STATUS,
    LIMIT_TYPE,
    UI_LANGUAGE,
    KYC_PROVIDER,
    ID_DOCUMENT_TYPE,
    PHONE_NUMBER,
    IS_LOW_RISK,
    SCREEN,
    IS_IMPROVED_RATE,
    FLOW,
    RECIPIENT_TYPE,
    PAYMENT_METHOD_CATEGORY,
    PAYMENT_COUNTRY,
    PAYMENT_CURRENCY,
    PAYOUT_METHOD_CATEGORY,
    PAYOUT_COUNTRY,
    PAYOUT_CURRENCY,
    PAYOUT_METHOD,
    PAYMENT_METHOD_TYPE,
    PERIOD,
    PHONE_COUNTRY,
    NEW_PHONE_COUNTRY,
    TOS_TYPE,
    FIELD_NAME,
    FIELD_VALUE,
    SOF,
    ERROR,
    ICON_TYPE,
    ARTICLE,
    SECTION,
    TRANSFER_COUNT,
    BANNER_NAME,
    BUTTON_VARIANT,
    CATEGORY,
} as const;

export type AmplitudeParamNameKey = keyof typeof AMPLITUDE_PARAM_NAMES;
export type AmplitudeParamNameValue = (typeof AMPLITUDE_PARAM_NAMES)[AmplitudeParamNameKey];
